var _metadata, _defs, _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeypadComponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg59",
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    stroke: "none",
    fill: "none",
    viewBox: "0.0 0.0 348.0 348.0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata65"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs63"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    clipRule: "nonzero",
    d: "m0 0l348.0 0l0 348.0l-348.0 0l0 -348.0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g57",
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5",
    fillRule: "nonzero",
    d: "M 0,0 H 348 V 348 H 0 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    fillRule: "nonzero",
    d: "M -6,0 H 342 V 347.9685 H -6 Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    fillRule: "nonzero",
    d: "m 5.07874,5.7758217 h 336.9134 V 343.44512 H 5.07874 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    fillRule: "nonzero",
    d: "m 5.07874,5.7758217 h 336.9134 V 343.44512 H 5.07874 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    fillRule: "nonzero",
    d: "m 282.73444,40.553925 v 0 c 0,-8.375591 6.96603,-15.165352 15.55905,-15.165352 v 0 c 4.12653,0 8.08402,1.597773 11.00192,4.441828 2.91788,2.844057 4.55713,6.701422 4.55713,10.723524 v 0 c 0,8.375595 -6.966,15.165356 -15.55905,15.165356 v 0 c -8.59302,0 -15.55905,-6.789761 -15.55905,-15.165356 z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    fillRule: "nonzero",
    d: "m 282.73444,40.553925 v 0 c 0,-8.375591 6.96603,-15.165352 15.55905,-15.165352 v 0 c 4.12653,0 8.08402,1.597773 11.00192,4.441828 2.91788,2.844057 4.55713,6.701422 4.55713,10.723524 v 0 c 0,8.375595 -6.966,15.165356 -15.55905,15.165356 v 0 c -8.59302,0 -15.55905,-6.789761 -15.55905,-15.165356 z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    fillRule: "nonzero",
    d: "M 38.37008,95.73661 H 145.58269 V 195.92558 H 38.37008 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    fillRule: "nonzero",
    d: "M 38.37008,95.73661 H 145.58269 V 195.92558 H 38.37008 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    fillRule: "nonzero",
    d: "m 111.96075,161.6141 -0.65625,4.90625 q -1.3125,0.15625 -2.34375,0.15625 -1.125,0 -2.4375,-0.1875 -7.749996,-1.09375 -7.749996,-8.65625 0,-0.96875 0.125,-1.875 l 2.031246,-14.8125 -23.812496,15.40625 -0.75,-0.0937 3.75,-26.59375 q 0.125,-0.875 0.125,-1.46875 0,-4.15624 -4.1875,-4.15624 -1.78125,0 -4.0625,0.375 l 0.71875,-4.90625 q 1.375,-0.15625 2.34375,-0.15625 1.0625,0 2.40625,0.1875 7.78125,1.09375 7.78125,8.65624 0,0.96875 -0.125,1.875 l -2.125,15.15625 23.843746,-15.46875 0.71875,0.0625 -3.6875,26.3125 q -0.125,0.90625 -0.125,1.46875 0,4.21875 4.1875,4.21875 1.84375,0 4.03125,-0.40625 z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    fillRule: "nonzero",
    d: "M 152.48032,95.73661 H 259.6929 V 195.92558 H 152.48032 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    fillRule: "nonzero",
    d: "M 152.48032,95.73661 H 259.6929 V 195.92558 H 152.48032 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27",
    fillRule: "nonzero",
    d: "m 229.14911,164.9891 q -3.34375,1.96875 -7.53125,1.96875 -5.125,0 -9.09375,-1.8125 -4,1.8125 -9.125,1.8125 -9.8125,0 -14.875,-6.875 -4.59375,-6.25 -4.59375,-17.15625 0,-10.3125 4.5,-16.82812 4.5,-6.51562 11.6875,-6.51562 4.1875,0 6.90625,1.75 l -2.5,4.53125 q -1.8125,-1.09375 -4.40625,-1.09375 -4.46875,0 -7.28125,5.56249 -2.65625,5.1875 -2.65625,12.5625 0,8.09375 2.90625,13.03125 3.40625,5.84375 10.3125,5.84375 2.0625,0 3.875,-0.4375 -5.59375,-6.09375 -5.59375,-18 0,-18.56249 11.28125,-18.56249 5.15625,0 8.03125,5.62499 2.5625,5.09375 2.5625,12.9375 0,11.875 -5.71875,18 1.84375,0.4375 3.84375,0.4375 2.59375,0 4.96875,-1.5 z m -11.28125,-21.65625 q 0,-5.3125 -1.15625,-9 -1.34375,-4.28125 -3.75,-4.28125 -5.4375,0 -5.4375,13 0,10.9375 5.0625,15.5625 5.28125,-4.71875 5.28125,-15.28125 z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path29",
    fillRule: "nonzero",
    d: "M 38.37008,206.52081 H 145.58269 V 306.70978 H 38.37008 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31",
    fillRule: "nonzero",
    d: "M 38.37008,206.52081 H 145.58269 V 306.70978 H 38.37008 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33",
    fillRule: "nonzero",
    d: "m 111.89825,254.39832 q 0,14.8125 -10.5,20.5625 -5.062496,2.78125 -11.124996,2.78125 -6.78125,0 -11.5,-3.4375 -4.71875,-3.4375 -6.59375,-9.90625 l 5.96875,-1.40625 q 3.0625,9.5625 12.25,9.5625 10.656246,0 13.812496,-9.34375 1.4375,-4.28125 1.4375,-8.78125 0,-12.53125 -6.999996,-16.71875 -3.59375,-2.15625 -7.78125,-2.15625 -10.875,0 -13.40625,11.65625 l -6.0625,-1.53125 q 1.84375,-7.25 6.65625,-11.21875 4.9375,-4.09375 12.3125,-4.09375 14.156246,0 19.124996,11.75 2.40625,5.6875 2.40625,12.28125 z m -24.312496,-3.0625 h 6.40625 v 6.40625 h -6.40625 z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path35",
    fillRule: "nonzero",
    d: "M 152.48032,206.52081 H 259.6929 V 306.70978 H 152.48032 Z",
    fillOpacity: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37",
    fillRule: "nonzero",
    d: "M 152.48032,206.52081 H 259.6929 V 306.70978 H 152.48032 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39",
    fillRule: "nonzero",
    d: "m 210.47723,257.74207 h -6.40625 v -6.40625 h 6.40625 z m 16.1875,4.6875 q -1.84375,7.25 -6.65625,11.21875 -4.9375,4.09375 -12.3125,4.09375 -14.125,0 -19.09375,-11.75 -2.4375,-5.75 -2.4375,-12.28125 0,-14.8125 10.53125,-20.59375 5.03125,-2.75 11.09375,-2.75 6.78125,0 11.5,3.4375 4.71875,3.4375 6.59375,9.90625 l -5.96875,1.40625 q -3.0625,-9.5625 -12.25,-9.5625 -4.9375,0 -8.5,2.3125 -3.78125,2.46875 -5.3125,7 -1.4375,4.28125 -1.4375,8.8125 0,12.53125 7,16.71875 3.59375,2.15625 7.78125,2.15625 10.875,0 13.40625,-11.65625 z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41",
    fillRule: "nonzero",
    d: "m 82.10236,102.04987 h 19.74803 v 5.63779 H 82.10236 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43",
    fillRule: "nonzero",
    d: "m 82.10236,102.04987 h 19.74803 v 5.63779 H 82.10236 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path45",
    fillRule: "nonzero",
    d: "m 196.2126,102.04987 h 19.74803 v 5.63779 H 196.2126 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path47",
    fillRule: "nonzero",
    d: "m 196.2126,102.04987 h 19.74803 v 5.63779 H 196.2126 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path49",
    fillRule: "nonzero",
    d: "m 82.10236,213.52493 h 19.74803 v 5.6378 H 82.10236 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path51",
    fillRule: "nonzero",
    d: "m 82.10236,213.52493 h 19.74803 v 5.6378 H 82.10236 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path53",
    fillRule: "nonzero",
    d: "m 196.2126,213.52493 h 19.74803 v 5.6378 H 196.2126 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path55",
    fillRule: "nonzero",
    d: "m 196.2126,213.52493 h 19.74803 v 5.6378 H 196.2126 Z",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeypadComponent);
export default __webpack_public_path__ + "static/media/KeypadComponent.f0035950ba7664687ba3c81dc6289fd0.svg";
export { ForwardRef as ReactComponent };